<template>
  <div id="app">
      
        <profile  />
        <startUp />
        <badgeAlert />
      

    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import profile from './components/profile'
import animatedLogo from './components/animatedLogo'
import gamePeterPan from './components/rides/peterPan/game'
import startUp from './components/startup'
import badgeAlert from './components/badgeAlert'

export default {
  name: 'app',
  components: {
    profile,
    animatedLogo,
    gamePeterPan,
    startUp,
    badgeAlert
  },

  data: function () {
    return {
      profileOpened: false
    }
  },

  watch: {
    '$store.state.onboarded': {
      deep: true,
      handler (newVal) {
        console.log(newVal)
      }
    }
  },
  sockets: {
  },
  methods: {
  },
  mounted () {
  }
}
</script>


<!-- Classroom.vue -->
<style lang="scss">
@import "sass/style.scss";

</style>



// WEBPACK FOOTER //
// src/App.vue